import { useEffect } from "react";
import Lenis from "lenis";
import { initAnalytics } from "./lib/analytics";
import Nav from "./components/site/Nav";
import Hero from "./components/site/Hero";
import Marquee from "./components/site/Marquee";
import Manifesto from "./components/site/Manifesto";
import Prototypes from "./components/site/Prototypes";
import TourInteractivo from "./components/site/TourInteractivo";
import Amenities from "./components/site/Amenities";
import Location from "./components/site/Location";
import FinalCta from "./components/site/FinalCta";
import Footer from "./components/site/Footer";
import WhatsAppFloat from "./components/site/WhatsAppFloat";
import AdminLeads from "./components/site/AdminLeads";

export default function App() {
  useEffect(() => {
    initAnalytics();
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  if (window.location.pathname.startsWith("/admin")) {
    return <AdminLeads />;
  }

  return (
    <div className="grain bg-[#1c242f] text-[#f4f2ea] antialiased" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Prototypes />
        <TourInteractivo />
        <Amenities />
        <Location />
        <FinalCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
